"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OverlayService_1 = require("src/OverlayService");
var useBodyScrollLock = function (dependencies) {
    React.useEffect(function () {
        var shouldLock = dependencies.some(function (dependency) { return dependency; });
        if (shouldLock) {
            OverlayService_1.overlayService.enableBodyScrollLock();
        }
        else {
            OverlayService_1.overlayService.disableBodyScrollLock();
        }
    }, [dependencies]);
};
exports.default = useBodyScrollLock;
